import React from 'react'

import withRouter from 'Pods/Shared/withRouter'

import CreateProjectForm from './Components/CreateProjectForm'

const ProjectsRepostForm = (props) => {
  return (
    <div className="container-fixed">
      <CreateProjectForm
        scope="repost"
        id={props.match && props.match.params.id}
      />
    </div>
  )
}

export default withRouter(ProjectsRepostForm)
